import { FC, useContext, useEffect, useState } from 'react'
import { MdArrowDropDown, MdArrowRight } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { SheetContext, SidebarContext } from '../../../lib/Context'
import { useAuthenticatedUser } from '../../../lib/Hooks/User'
import Headline from '../../Elements/Headline'
import Text from '../../Elements/Text'
import Button from '../../Formik/Button'
import { useDeleteSheet } from '../lib/Hooks/Sheet'
import { getImperativName } from './lib/Naming'

type Props = Record<string, never>

const Deletion: FC<Props> = () => {
  const { t } = useTranslation('configuration')
  const { sheet } = useContext(SheetContext)
  const { showSidebar } = useContext(SidebarContext)
  const navigate = useNavigate()
  const { data: authenticatedUser } = useAuthenticatedUser()
  const [isExpanded, toggleExpanded] = useState(false)
  const { mutate: deleteSheet, isPending, isSuccess } = useDeleteSheet()

  useEffect(() => {
    if (isSuccess) {
      showSidebar(null)
      return navigate('/')
    }
  }, [isSuccess])

  return (
    <>
      {sheet.author.id === authenticatedUser?.id && (
        <>
          <Headline className='mb-2'>
            <div
              className='flex items-center cursor-pointer'
              onClick={() => toggleExpanded(!isExpanded)}
            >
              {!isExpanded && <MdArrowRight size='1.25rem' />}
              {isExpanded && <MdArrowDropDown size='1.25rem' />}
              {t('configuration:deletion.heading')}
            </div>
          </Headline>
          {isExpanded && (
            <div className='ml-5 mb-5'>
              <Text className='mb-4'>
                {t('configuration:deletion.description', {
                  name: getImperativName(sheet.sheet_type),
                })}
              </Text>
              <Button
                theme='red'
                className='w-full'
                onClick={() => {
                  if (
                    !window.confirm(
                      t('configuration:deletion.confirmDelete', {
                        name: getImperativName(sheet.sheet_type),
                      }),
                    )
                  ) {
                    return
                  }
                  deleteSheet(sheet)
                }}
                loading={isPending}
              >
                {t('configuration:deletion.button')}
              </Button>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default Deletion
